import { mediaMin } from '@spa/shared/theme';
import styled from 'styled-components';

export const GroupItemsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 9px;

  ${mediaMin.compactPhoneBreakpoint`
    display: flex;
    flex-direction: column;
  `}
`;

export const FilterDescription = styled.p`
  font-size: ${props => props.theme.rem(14)};
  color: ${props => props.theme.checkbox.color};

  span {
    font-style: italic;
    padding-inline-start: 2px;
  }
`;
